import { API } from 'aws-amplify';
import { JobCategoryConfirmationInterface } from 'types/job-category-mapping';
import { authHeader } from 'utils/auth';

export async function getJobCategoryMapping(reportId: string): Promise<{
  jobMappingResult: JobCategoryConfirmationInterface[];
  isImportedJobMappingsComplete: boolean;
} | null> {
  const apiName = 'machineLearningAPI';
  const path = `/report/${reportId}/ml/job-category-mapping`;
  const headers = await authHeader();

  try {
    return await API.get(apiName, path, {
      headers
    });
  } catch (error) {
    console.log('Error: ', error);
    return null;
  }
}
